import { useEffect, useRef } from "react";

export function useTabDirectionFocus() {
  const lastTabDirection = useRef(null);

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === "Tab") {
        lastTabDirection.current = e.shiftKey ? "backward" : "forward";
      }
    }

    function handleKeyUp(e) {
      if (e.key === "Tab") {
        lastTabDirection.current = null;
      }
    }

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, []);

  return lastTabDirection;
}
